import { render, staticRenderFns } from "./AddFollowUp.vue?vue&type=template&id=0c859159&scoped=true"
import script from "./AddFollowUp.vue?vue&type=script&lang=js"
export * from "./AddFollowUp.vue?vue&type=script&lang=js"
import style0 from "./AddFollowUp.vue?vue&type=style&index=0&id=0c859159&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c859159",
  null
  
)

export default component.exports